import HomeScorecardCard from "./homeScorecardCard";
import PopUpScorecardFormFeedback from "../../../../popUpForms/popUpScorecardFormFeedback";
const CardScorecardShareFeedback = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeScorecardCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="scorecard-feedback"
      title="Share Feedback & Upload Your Scorecard"
      titleColor="var(--green)"
      popUpComponent={<PopUpScorecardFormFeedback />}
      content={[
        {
          type: "header-H5",
          color: "var(--gold)",
          text: "Support Creation of Global Best Practices",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Help us improve the scorecard by sending feedback, collaborating, and sharing learnings or best practices to accelerate our progress.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Any feedback or suggestions are welcome, whether it is for the website, scorecard, processes, or wildfires in general.",
        },
        {
          type: "button-group",
          buttons: [
            { text: "Upload Scorecard", color: "var(--green)" },
            { text: "Feedback", color: "var(--green)" },
          ],
        },
      ]}
    />
  );
};

export default CardScorecardShareFeedback;
